import { parseJsonArray } from '../lib/jsonColumn';
import { isPastDue } from './dates';
import { isAvenca, getAvencaMissingMonths, type AvencaFields } from './avenca';

/**
 * A campaign that still needs its client invoice issued. The dashboard card
 * and its modal must use this same rule, otherwise the count and the list
 * disagree.
 *
 * Creator campaigns (brand action, multi-influencer) are invoiced once every
 * deliverable is published and the campaign is at the billing stage.
 * Sponsorships and services have no deliverables: they are invoiced once the
 * work is underway or done — and for an event, once the event has happened.
 */
export function needsClientInvoice(campaign: AvencaFields & {
  campaign_mode?: string | null;
  company_invoice_status?: string | null;
  campaign_status?: string | null;
  delivery_status?: string | null;
  deliverables?: unknown;
  event_date?: string | null;
}): boolean {
  // Avenças: due whenever a month has come without its invoice — the
  // monthly reminder, whatever the campaign's overall status
  if (isAvenca(campaign)) return getAvencaMissingMonths(campaign).length > 0;

  if (campaign.company_invoice_status !== 'Not Issued') return false;
  const status = campaign.campaign_status || 'Consultation';
  const mode = campaign.campaign_mode || 'brand_action';

  if (mode === 'sponsorship' || mode === 'services') {
    if (status !== 'In Progress' && status !== 'Billing') return false;
    if (mode === 'sponsorship' && campaign.event_date && !isPastDue(campaign.event_date)) return false;
    return true;
  }

  if (status !== 'Billing') return false;
  const deliverables = parseJsonArray<{ status?: string }>(campaign.deliverables);
  return deliverables.length > 0
    ? deliverables.every((d) => d.status === 'Published')
    : campaign.delivery_status === 'Published';
}
